// extracted by mini-css-extract-plugin
export default {"siteIcon":"m_Zwg2"};